import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'
import providerListQuery, {

} from '../../../../__generated__/ProviderListQuery.graphql'
import {useQueryLoaderNowWithRetry} from '../../../../hooks/useQueryLoaderNow'
import ProviderList from '../../components/ProviderList/ProviderList'





const TeamIntegrationsRoot = ({teamId}) => {
  const {queryRef, retry} = useQueryLoaderNowWithRetry(providerListQuery, {
    teamId
  })
  return (
    _jsx('div', { className: "flex flex-col items-center px-4 py-0"    , children: 
      _jsx(Suspense, { fallback: '', children: 
        queryRef && _jsx(ProviderList, { queryRef: queryRef, teamId: teamId, retry: retry,} )
      })
    })
  )
}

export default TeamIntegrationsRoot
